/** @jsxRuntime classic */
/** @jsx jsx */
import React, { Component } from "react";
import { connect } from "react-redux";
import { jsx, css } from "@emotion/core";
import {
  primary_l50,
  primary_s5_l70,
  primary_s20_l87,
  primary_s10_l60,
} from "../lib/colors";

class A extends Component {
  render() {
    const cleanProps = { ...this.props };
    delete cleanProps.primaryColor;
    delete cleanProps.uiVariantButton;
    delete cleanProps.dispatch;

    const { uiVariantButton } = this.props;

    // console.log(this.props)
    const primaryColor = this.props.primary || this.props.primaryColor
    // const primaryColor = 'red'

    return (
      <a
        {...cleanProps}
        css={css`
          color: ${primaryColor};
          &:active,
          &.active {
            color: ${primaryColor};
            &:after {
              background-color: ${primaryColor};
            }
          }
          &:focus,
          &:hover {
            color: ${primary_l50(primaryColor)};
            &:after {
              background-color: ${primaryColor};
            }
          }
          &:focus,
          &:active,
          &:active:focus,
          &:not(:disabled):not(.disabled):active:focus {
            box-shadow: none;
            outline: none;
          }
          &.btn {
            font-size: ${uiVariantButton === "3" ? "14px" : "12px"};
            text-transform: ${uiVariantButton === "3" ? "none" : "uppercase"};
            letter-spacing: ${uiVariantButton === "3" ? "0" : "0.5px"};
            border-radius: ${uiVariantButton === "1"
              ? "12px"
              : uiVariantButton === "3"
              ? "6px"
              : 0};
          }
          &.btn-primary {
            color: white;
            background-color: ${primaryColor};
            border-color: ${primaryColor};
            &:focus,
            &:hover,
            &:not(:disabled):not(.disabled):active {
              background-color: ${primary_l50(primaryColor)};
              border-color: ${primary_l50(primaryColor)};
            }
            &.disabled {
              color: ${primary_s10_l60(primaryColor)};
              background-color: ${primary_s20_l87(primaryColor)};
            }
          }
          &.btn-inverse {
            background-color: transparent;
            color: white;
            border-color: white;
            &:focus,
            &:hover,
            &:not(:disabled):not(.disabled):active {
              background-color: white;
              color: ${primaryColor};
            }
          }
          &.btn-outline {
            background-color: transparent;
            color: ${uiVariantButton === "3" ? "#4f4f4f" : primaryColor};
            border-width: 1px;
            border-style: solid;
            border-color: ${primaryColor};
            &:focus,
            &:hover,
            &:not(:disabled):not(.disabled):active {
              background-color: ${primaryColor};
              color: white !important;
            }
          }
          &.btn-grey {
            background-color: transparent;
            color: ${primary_s5_l70(primaryColor)};
            border-color: ${primary_s5_l70(primaryColor)};
            &:focus,
            &:hover,
            &:not(:disabled):not(.disabled):active {
              background-color: ${primary_s5_l70(primaryColor)};
              color: white;
            }
          }
          &.add-to-cart {
            color: white;
            background-color: ${primaryColor};
            &:focus,
            &:hover,
            &:not(:disabled):not(.disabled):active {
              background-color: ${primary_l50(primaryColor)};
            }
            &.disabled {
              color: ${primary_s10_l60(primaryColor)};
              background-color: ${primary_s20_l87(primaryColor)};
            }
          }
        `}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  primaryColor: state.store.singleStore.brandColor,
  uiVariantButton: state.store.singleStore.buttons,
});

export default connect(mapStateToProps)(A);
